import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm, isPristine } from 'redux-form';
import { connect } from 'react-redux';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import RenderDateInputField from 'components/form/InputFields/RenderDateInputField';
import utils from 'helpers/utils';

class DiscountCodesEditForm extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        initialize({
            amount: data.amount,
            currency: data.currency,
            expiry_date: data.expiry_date,
            is_enabled: data.is_enabled,
            percentage: `${ parseFloat(data.percentage) * 100 }`,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        const booleanInputLabelStyle = {
            color: 'rgba(0, 0, 0, 0.298039)',
        };

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    label={ translate('resources.discount_codes.fields.is_enabled') }
                                    labelStyle={ booleanInputLabelStyle }
                                    name='is_enabled'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderDateInputField }
                                    label={ translate('resources.discount_codes.fields.expiry_date') }
                                    name='expiry_date'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderPercentageInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.discount_codes.fields.percentage') }
                                    name='percentage'
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    choices={
                                        utils.map(this.context.config.currency.supported, (currency) => {
                                            return {
                                                label: currency,
                                                value: currency,
                                            };
                                        })
                                    }
                                    component={ RenderAutoCompleteInputField }
                                    label={ translate('resources.discount_codes.fields.currency') }
                                    name='currency'
                                    optionText='label'
                                    optionValue='value'
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.discount_codes.fields.amount') }
                                    name='amount'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting || invalid || pristine }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

DiscountCodesEditForm.contextTypes = {
    config: PropTypes.object,
};

DiscountCodesEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
        pristine: isPristine(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(DiscountCodesEditForm);



// WEBPACK FOOTER //
// ./src/pages/discountCodes/edit/DiscountCodesEditForm.js